import {
  CHART_CANVAS_HEIGHT, CHART_HEIGHT_GAP, CHART_HEIGHT_MM, PIXEL_COEFFICIENT,
} from '../constants';

const getBarHeightCoefficient = (maximum, withGap) => ((withGap ? CHART_CANVAS_HEIGHT : CHART_HEIGHT_MM) * PIXEL_COEFFICIENT)
  / (withGap ? maximum + CHART_HEIGHT_GAP : maximum);

export default getBarHeightCoefficient;
